// extracted by mini-css-extract-plugin
module.exports = {"selectedSolutions":"styles_selectedSolutions__3Ckkh","selectedSolutions_map":"styles_selectedSolutions_map__2anLH"};